/* eslint-disable perfectionist/sort-imports */
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import 'src/global.css';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import Router from 'src/routes/sections';
import ThemeProvider from 'src/theme';

export default function App() {
  useScrollToTop();

  useEffect(() => {
    ReactGA.initialize(import.meta.env.VITE_GTM);
  }, []);

  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}
